/* Bordamar v13 · mejoras de la auditoría 16/10 */
(function () {
  /* 1 · Aviso visual cuando el precio cambia al elegir color o talla en la ficha */
  function watchPrice(pp) {
    if (pp.__bmWatch) return; pp.__bmWatch = true;
    var last = (pp.querySelector('[ref="priceContainer"] .price') || {}).textContent;
    new MutationObserver(function () {
      var box = pp.querySelector('[ref="priceContainer"]');
      var now = box && (box.querySelector('.price') || {}).textContent;
      if (box && now && last && now.trim() !== last.trim()) {
        box.classList.remove('bm-flash'); void box.offsetWidth; box.classList.add('bm-flash');
        var live = pp.querySelector('.bm-price-live');
        if (live) live.textContent = 'Nuevo precio: ' + now.trim();
      }
      if (now) last = now;
    }).observe(pp, { childList: true, subtree: true, characterData: true });
  }
  function init() { document.querySelectorAll('product-price[data-bm-pdp]').forEach(watchPrice); }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  /* 2 · Barra fija de la ficha: «Elige tu talla» hasta que el cliente elige una; después «Añadir al carrito» */
  function sizeFs() { return document.querySelector('main fieldset.variant-option.bm-sz'); }
  function unpicked() { var fs = sizeFs(); return !!(fs && fs.classList.contains('bm-unpicked')); }
  function atc() { return document.querySelector('main form[action*="/cart/add"] button[type=submit]'); }
  function syncBar() {
    var bar = document.querySelector('.bm-sticky'); if (!bar) return;
    var b = bar.querySelector('button'); if (!b) return;
    if (!bar.__bmObs) { bar.__bmObs = true; new MutationObserver(schedBar).observe(bar, { subtree: true, childList: true, characterData: true, attributes: true }); }
    var want = unpicked() ? 'Elige tu talla' : 'Añadir al carrito';
    if (b.textContent !== want) b.textContent = want;
    b.classList.toggle('bm13-pick', unpicked());
    if (!b.__bm13) {
      b.__bm13 = true;
      b.addEventListener('click', function (e) {
        e.preventDefault(); e.stopImmediatePropagation();
        var fs = sizeFs();
        if (unpicked() && fs) {
          window.scrollTo({ top: fs.getBoundingClientRect().top + window.scrollY - 110, behavior: 'smooth' });
          fs.classList.remove('bm-flash'); void fs.offsetWidth; fs.classList.add('bm-flash');
          return;
        }
        var a = atc();
        if (a && !a.disabled) a.click(); else if (a) a.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }, true);
    }
  }
  var st; function schedBar() { clearTimeout(st); st = setTimeout(syncBar, 60); }
  function initBar() {
    if (!document.querySelector('main[data-template^="product"]')) return;
    syncBar();
    new MutationObserver(schedBar).observe(document.querySelector('main'), { subtree: true, attributes: true, attributeFilter: ['class'] });
    new MutationObserver(schedBar).observe(document.body, { childList: true });
  }
  if (document.readyState !== 'loading') initBar(); else document.addEventListener('DOMContentLoaded', initBar);
  /* 4 · Talla sin errores */
  var MINT = { 'menta': '#2f9e7f', 'mint': '#2f9e7f', 'menta oscuro': '#1f7a63', 'verde mist': '#9fbfae' };
  function norm(s) { return (s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase().trim(); }
  function sizesFix() {
    var fs = sizeFs();
    if (fs) {
      /* enlace «¿Qué talla soy?»: siempre presente y en su propia línea, también tras cambiar de color */
      if (!fs.querySelector('.bm-sizelink')) {
        var box = document.querySelector('[data-bm-ask]');
        var lg = fs.querySelector('legend');
        if (box && lg && box.querySelector('[data-q="talla"]')) {
          var a = document.createElement('button');
          a.type = 'button'; a.className = 'bm-sizelink'; a.textContent = '¿Qué talla soy? Calcúlala en 10 segundos';
          a.addEventListener('click', function () { var c = box.querySelector('[data-q="talla"]'); if (c) c.click(); box.scrollIntoView({ behavior: 'smooth', block: 'center' }); });
          lg.after(a);
        }
      } else {
        var sl = fs.querySelector('.bm-sizelink');
        if (/^\D*¿Qué talla soy\?$/.test(sl.textContent.trim())) sl.textContent = '¿Qué talla soy? Calcúlala en 10 segundos';
      }
      /* tallas infantiles plegadas tras un botón */
      var labels = [].slice.call(fs.querySelectorAll('label.variant-option__button-label'));
      var kids = labels.filter(function (l) { var i = l.querySelector('input'); return i && /^\d{1,2}\/\d{1,2}$/.test(i.value.trim()); });
      if (kids.length && kids.length < labels.length) {
        kids.forEach(function (l) { l.classList.add('bm13-kid'); });
        if (kids.some(function (l) { var i = l.querySelector('input'); return i && i.checked && !fs.classList.contains('bm-unpicked'); })) fs.classList.add('bm13-kids-open');
        if (!fs.querySelector('.bm13-kidsbtn')) {
          var kb = document.createElement('button');
          kb.type = 'button'; kb.className = 'bm13-kidsbtn'; kb.textContent = '+ Ver tallas infantiles';
          kb.addEventListener('click', function () { fs.classList.add('bm13-kids-open'); });
          var anchor = fs.querySelector('.bm10-kids') || kids[0];
          anchor.before(kb);
        }
      }
    }
    /* calculadora: que los números de ejemplo no parezcan ya rellenos */
    document.querySelectorAll('.bm-calc input[placeholder]').forEach(function (i) { if (!/^Ej/.test(i.placeholder)) i.placeholder = 'Ej.: ' + i.placeholder; });
    /* colores sin muestra (p. ej. «MO»): ponerles su color */
    document.querySelectorAll('main .bm-dot--none').forEach(function (d) {
      var l = d.closest('label'); var n = norm(l && l.getAttribute('title'));
      var hex = MINT[n] || (n.indexOf('menta') > -1 ? MINT.menta : null);
      if (hex) { d.classList.remove('bm-dot--none'); d.textContent = ''; d.style.background = hex; }
    });
  }
  var sf; function schedSizes() { clearTimeout(sf); sf = setTimeout(sizesFix, 120); }
  function initSizes() {
    var m = document.querySelector('main[data-template^="product"]'); if (!m) return;
    sizesFix();
    new MutationObserver(schedSizes).observe(m, { childList: true, subtree: true });
  }
  if (document.readyState !== 'loading') initSizes(); else document.addEventListener('DOMContentLoaded', initSizes);
  /* 3 · Carrito: «Total (sin envío)» y barra fija con «Pagar» en móvil */
  function labelTotals() {
    document.querySelectorAll('.cart__total-label').forEach(function (l) { if (l.textContent.trim() === 'Total estimado') l.textContent = 'Total (sin envío)'; });
  }
  function initCartBar() {
    labelTotals();
    var m = document.querySelector('main[data-template="cart"]'); if (!m) return;
    var bar = document.createElement('div');
    bar.className = 'bm13-cartbar'; bar.setAttribute('role', 'region'); bar.setAttribute('aria-label', 'Resumen del pedido');
    bar.innerHTML = '<div class="bm13-cartbar__t"><small>Total (sin envío)</small><b></b></div><button type="button">Pagar</button>';
    document.body.appendChild(bar);
    var visible = false;
    function chk() { return document.getElementById('checkout'); }
    function sync() {
      labelTotals();
      var v = document.querySelector('main .cart__total-value'), c = chk();
      bar.querySelector('b').textContent = v ? v.textContent.trim() : '';
      var on = !!(v && c && !c.disabled && !visible);
      bar.classList.toggle('is-on', on); document.body.classList.toggle('bm13-cartbar-on', on);
      if (c && !c.__bm13io) { c.__bm13io = true; new IntersectionObserver(function (en) { visible = en[0].isIntersecting; sync(); }).observe(c); }
    }
    bar.querySelector('button').addEventListener('click', function () { var c = chk(); if (c && !c.disabled) c.click(); });
    sync();
    var t; new MutationObserver(function () { clearTimeout(t); t = setTimeout(sync, 120); }).observe(m, { childList: true, subtree: true, characterData: true });
  }
  if (document.readyState !== 'loading') initCartBar(); else document.addEventListener('DOMContentLoaded', initCartBar);
  var lt; try { new MutationObserver(function () { clearTimeout(lt); lt = setTimeout(labelTotals, 150); }).observe(document.body, { childList: true, subtree: true }); } catch (e) {}
})();
